import { RecipientRole } from 'features/document/constants';
import { ReactComponent as NeedsToSignIcon } from 'assets/images/RecipientRoleIcons/needs_to_sign.svg';
import { ReactComponent as NeedsToViewIcon } from 'assets/images/RecipientRoleIcons/needs_to_view.svg';
import { ReactComponent as ReceivesACopyIcon } from 'assets/images/RecipientRoleIcons/receives_a_copy.svg';

export const recipientRoleOptions = [
  {
    value: RecipientRole.SIGNER,
    label: 'Needs to sign',
    Icon: NeedsToSignIcon,
  },
  {
    value: RecipientRole.VIEWER,
    label: 'Needs to view',
    Icon: NeedsToViewIcon,
  },
  {
    value: RecipientRole.COPY,
    label: 'Receives a copy',
    Icon: ReceivesACopyIcon,
  },
];
